<template>
  <div class="page">
    <div class="fixed-box">
      <div class="back-bar">
        <feather-icon
          class="pointer"
          @click="goBack"
          icon="ChevronLeftIcon"
        ></feather-icon>
        <span class="small-title">流水详情</span>
      </div>
    </div>
    <div class="page-header white-bg">
              <size-change @sizeChange="sizeChange"></size-change>
      <div class="header-right">
        <vs-input
          class="search-words"
          v-model="words"
          placeholder="子订单号"
        ></vs-input>
        <vs-button class="search-btn" type="filled" color="primary" @click="toQuery">搜索</vs-button>
      </div>
    </div>
    <div class="page-content white-bg">
      <vs-table
        :data="listData"
      >
        <template slot="thead">
          <vs-th>
            子订单号
          </vs-th>
          <vs-th>
            存币数量
          </vs-th>
          <vs-th>
            备注
          </vs-th>
          <vs-th>
             订单时间
          </vs-th>
          <vs-th class="status-col">
            订单状态
          </vs-th>
          <vs-th>
            操作
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(tr, index) in data" >
            <vs-td @click.native.stop="orderIdHandle(tr)">
              <span
                class="order-span"
                :class="{on: getActive(tr)}"
              >
                {{tr.transactionId}}
              </span>
            </vs-td>

            <vs-td>
              {{tr.amount}}
            </vs-td>

            <vs-td>
<!--              沒有备注-->
              <div>{{tr.remark}}</div>
            </vs-td>
            <vs-td>
              <div>{{tr.createTime}}</div>
            </vs-td>
            <vs-td class="status-col">
<!--              red: tr.status == 203,-->
                <span
                  class="status"
                  :class="{
                  grey: tr.status == 5 ,
                   green: tr.status == 4,

                   orange: tr.status == 3
                   }"
                >{{getState(tr)}}</span>
            </vs-td>
            <vs-td>
              <div class="centerx">

                <el-tooltip
                  v-if="tr.status == 4"
                  class="item"
                  effect="dark"
                  content="手动上账"
                  placement="top"
                >
                  <icon-svg
                    icon-class="credit-card1"
                    class="pointer edit-icon"
                    @click.native="selfHandle(tr)"
                  ></icon-svg>
                </el-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="pagination-outer" v-if="total">
        <span class="tatol-count">共计{{total}}条</span>
        <vs-pagination
          class="pagination-box"
          :max="size"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <confirm-dialog
      :dialog-show="dialogShow"
      @confirm="confirm"
      @cancel="cancel"
    ></confirm-dialog>
  </div>
</template>

<script>
  import { confirmApiTrans } from '@/api/wallet'
  import confirmDialog from '../../../components/public/deleteDialog'
  import querySelect from '@/components/walletManage/api/querySelect'
  import initData from '@/mixins/initData'
  import sizeChange from '@/components/public/sizeChange'
  export default {
    name: "index",
    components:{
      sizeChange,
      querySelect,
      confirmDialog,
    },
    data() {
      return {
        currTansactionId: '',
        dialogShow: false,
      }
    },
    mixins: [initData],
    mounted(){
      this.init();
    },
    methods: {
      goBack(){
        this.$store.commit('setBeforePage', this.$route.query.page);
        this.$router.go(-1);
      },
      beforeInit(){
        this.url = 'pms/crm/apiWalletTransDetail';
        this.params = {
          page: this.page,
          size: this.size,
          serialNo: this.$route.params.id,
        }
        if(this.words){
          this.params.transactionId = this.words;
        }
        return true;
      },
      orderIdHandle(row){
        if(row.tradeUrl){
          window.open(row.tradeUrl);
        }
      },
      getState(tr){
        switch (+tr.status) {
          case 1:
            return '待审核';
            break;
          case 2:
            return '待支付';
            break;
          case 3:
            return '支付中';
            break;
          case 4:
            return '已支付';
            break;
          case 5:
            return '已完成';
            break;
          case 6:
            return '审核拒绝';
            break;
        }
      },
      getActive(tr){
        return tr.tradeUrl;
      },
      selfHandle(tr){
        this.currTansactionId = tr.transactionId;
        this.dialogShow = true;

      },
      confirm(){
        confirmApiTrans({
          transactionId: this.currTansactionId,
        }).then((res) => {
          console.log(res);
          this.dialogShow = false;
          this.$vs.notify({
            text: '上账成功',
            position: 'top-right'
          });
          this.init();
        }).catch((error) => {
          this.dialogShow = false;
        })
      },
      cancel(){
        this.dialogShow = false;
      },

    },
  }
</script>
<style lang="scss">
  .page {
    .vs-table--thead th {
      padding-top: 17px!important;
      padding-bottom: 17px!important;
      color: #5E5873;
      background-color: #F3F2F7;
    }
  }
</style>
<style lang="scss" scoped>
  .fixed-box {
    background-color: #ffffff;
    width: 100%;
    margin-bottom: 1.7rem;
    .back-bar {
      height: 5rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 1rem;
      border-bottom: 1px solid #EBE9F1;
      .small-title {
        margin-left: 10px;
        font-size: 20px;
        font-weight: 500;
      }
    }
  }
  .centerx {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .query-box {
    margin-bottom: 1.7rem;
  }
  .page-header {
    .header-right {
      .search-words {
        display: inline-block;
      }
      .search-btn,
      .search-words {
        margin-right: 10px;
      }
    }
  }
  .page-content {
    padding-bottom: 1.4rem;
  }

  .merchant-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;

  }
  .edit-icon {
    font-size: 22px;
  }
  .status {
    display: inline-block;
    padding: 5px 10px;
    border-radius: 17px;
    &.red {
      background-color: rgba(234, 84, 85, 0.12);
      color: #EA5455;
    }
    &.green {
      background-color: rgba(0, 128, 0, 0.12);
      color: green;
    }
    &.orange {
      background-color: rgba(255, 165, 0, 0.12);
      color: orange;
    }
    &.grey {
      background-color: rgba(128, 128, 128, 0.12);
      color: grey;
    }
  }
</style>
